import { render } from "./2025Results.vue?vue&type=template&id=cf7715d2"
import script from "./2025Results.vue?vue&type=script&lang=js"
export * from "./2025Results.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\shawn\\sloppy-golf\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__